import {
  Button,
  Checkbox,
  Grid,
  IconButton,
  ListItemText,
  Tooltip
} from '@mui/material';
import React, { Component } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import DateRange from 'src/components/common/DateRange';
import PropTypes from 'prop-types';
import ClearIcon from '@mui/icons-material/Clear';
import goodalipi from 'src/plugins/goodalipi';

class SearchRecords extends Component {
  constructor(props) {
    super(props);
    this.state = this.props.filter;
    this.globalHR = goodalipi.get('globalHR');
  }
  handleChange(type, value) {
    let {
      dateRange,
      campLocation,
      providerName,
      campType,
      benf,
      payment,
      entityRequested
    } = this.setState;
    switch (type) {
      case 'dateRange':
        dateRange = value;
        break;
      case 'campLocation':
        campLocation = value;
        break;
      case 'campType':
        campType = value;
        break;
      case 'providerName':
        providerName = value;
        break;
      case 'benf':
        benf = value;
        break;
      case 'payment':
        payment = value;
        break;
      case 'entityRequested':
        entityRequested = value;
    }
    let obj = {};
    if (dateRange) {
      obj.dateRange = dateRange;
    }
    if (campLocation) {
      obj.campLocation = campLocation;
    }
    if (providerName) {
      obj.providerName = providerName;
    }
    if (campType) {
      obj.campType = campType;
    }
    if (benf) {
      obj.benf = benf;
    }
    if (payment) {
      obj.payment = payment;
    }
    if (entityRequested) {
      obj.entityRequested = entityRequested;
    }
    console.log('85 line', entityRequested);
    this.setState(obj, () => {
      this.props.setFilters(this.state);
    });
  }
  render() {
    return (
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {/* left side */}
        <Grid item container spacing={2} sm={8} xs={12}>
          {this.state.hasOwnProperty('campLocation') ? (
            <Grid item sm={2.4} xs={12}>
              <FormControl size="small" variant="outlined" fullWidth>
                <InputLabel id="city-select">Location</InputLabel>
                <Select
                  multiple
                  value={this.state.campLocation}
                  onChange={(ev) => {
                    this.handleChange('campLocation', ev.target.value);
                  }}
                  renderValue={(selected) => selected.join(', ')}
                  label="Location"
                >
                  {typeof this.props.filterOptions.campLocationList !==
                    'undefined' &&
                    this.props.filterOptions.campLocationList.map(
                      (val, idx) => (
                        <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                          <Checkbox
                            color="primary"
                            // icon={<RadioButtonUncheckedIcon/>}
                            // checkedIcon={<CheckCircleIcon/>}
                            size="small"
                            checked={
                              this.state.campLocation.length &&
                              this.state.campLocation.indexOf(val) > -1
                            }
                          />
                          <ListItemText primary={val} />
                        </MenuItem>
                      )
                    )}
                </Select>
              </FormControl>
            </Grid>
          ) : null}
          {this.state.hasOwnProperty('providerName') ? (
            <Grid item sm={2.4} xs={12}>
              <FormControl size="small" variant="outlined" fullWidth>
                <InputLabel id="provider-select">Provider</InputLabel>
                <Select
                  multiple
                  labelId="provider-select"
                  value={this.state.providerName}
                  onChange={(ev) => {
                    this.handleChange('providerName', ev.target.value);
                  }}
                  renderValue={(selected) => selected.join(', ')}
                  label="Provider"
                >
                  {typeof this.props.filterOptions.providerNameList !==
                    'undefined' &&
                    this.props.filterOptions.providerNameList.map(
                      (val, idx) => (
                        <MenuItem sx={{ py: 0 }} key={idx} value={val}>
                          <Checkbox
                            color="primary"
                            // icon={<RadioButtonUncheckedIcon/>}
                            // checkedIcon={<CheckCircleIcon/>}
                            size="small"
                            checked={
                              this.state.providerName.length &&
                              this.state.providerName.indexOf(val) > -1
                            }
                          />
                          <ListItemText primary={val} />
                        </MenuItem>
                      )
                    )}
                </Select>
              </FormControl>
            </Grid>
          ) : null}
          {this.state.hasOwnProperty('campType') ? (
            <Grid item sm={2.4} xs={12}>
              <FormControl size="small" variant="outlined" fullWidth>
                <InputLabel id="camp-select">Camp Type</InputLabel>
                <Select
                  multiple
                  labelId="camp-select"
                  value={this.state.campType}
                  onChange={(ev) => {
                    this.handleChange('campType', ev.target.value);
                  }}
                  renderValue={(selected) => selected.join(', ')}
                  label="Camp Type"
                >
                  {typeof this.props.filterOptions.campTypeList !==
                    'undefined' &&
                    this.props.filterOptions.campTypeList.map((val, idx) => (
                      <MenuItem sx={{ py: 0 }} key={idx} value={val}>
                        <Checkbox
                          color="primary"
                          // icon={<RadioButtonUncheckedIcon/>}
                          // checkedIcon={<CheckCircleIcon/>}
                          size="small"
                          checked={
                            this.state.campType.length &&
                            this.state.campType.indexOf(val) > -1
                          }
                        />
                        <ListItemText primary={val} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          ) : null}
          {this.state.hasOwnProperty('payment') ? (
            <Grid item sm={2.4} xs={12}>
              <FormControl size="small" variant="outlined" fullWidth>
                <InputLabel id="payment-select">Payment</InputLabel>
                <Select
                  // multiple
                  labelId="payment-select"
                  value={this.state.payment}
                  onChange={(ev) => {
                    this.handleChange('payment', ev.target.value);
                  }}
                  // renderValue={(selected) => selected.join(', ')}
                  label="Payment"
                >
                  {typeof this.props.filterOptions.paymetnList !==
                    'undefined' &&
                    this.props.filterOptions.paymetnList.map((val, idx) => (
                      <MenuItem sx={{ py: 0 }} key={idx} value={val}>
                        {/* <Checkbox
                          color="primary"
                          icon={<RadioButtonUncheckedIcon/>}
                          checkedIcon={<CheckCircleIcon/>}
                          size="small" checked={this.state.providerName.length && this.state.providerName.indexOf(val) > -1} /> */}
                        <ListItemText primary={val} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          ) : null}
          {this.state.hasOwnProperty('benf') ? (
            <Grid item sm={2.4} xs={12}>
              <FormControl size="small" variant="outlined" fullWidth>
                <InputLabel id="Beneficiary-select">Beneficiary</InputLabel>
                <Select
                  multiple
                  labelId="Beneficiary-select"
                  value={this.state.benf}
                  onChange={(ev) => {
                    this.handleChange('benf', ev.target.value);
                  }}
                  renderValue={(selected) => selected.join(', ')}
                  label="Beneficiary"
                >
                  {typeof this.props.filterOptions.benfList !== 'undefined' &&
                    this.props.filterOptions.benfList.map((val, idx) => (
                      <MenuItem sx={{ py: 0 }} key={idx} value={val}>
                        <Checkbox
                          color="primary"
                          // icon={<RadioButtonUncheckedIcon/>}
                          // checkedIcon={<CheckCircleIcon/>}
                          size="small"
                          checked={
                            this.state.benf.length &&
                            this.state.benf.indexOf(val) > -1
                          }
                        />
                        <ListItemText primary={val} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          ) : null}
        </Grid>
        {/* right side */}

        {this.globalHR &&
          typeof this.props.filterOptions.entityRequested !== 'undefined' && (
            <Grid item xs={12} sm={1.5}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel>EntityId</InputLabel>
                <Select
                  // multiple
                  value={this.state.entityRequested}
                  onChange={(ev) => {
                    this.handleChange('entityRequested', ev.target.value);
                  }}
                  // renderValue={(selected) => selected.join(', ')}
                  label="EntityId"
                >
                  {this.props.filterOptions.entityRequested.map((val, idx) => (
                    <MenuItem sx={{ py: 0 }} value={val.val} key={idx}>
                      <ListItemText primary={val.key} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

        <Grid item container spacing={2} alignItems="start" sm={4} xs={12}>
          {this.state.dateRange ? (
            <Grid item sm={9} xs={12}>
              <DateRange
                onDateChange={(value) => {
                  this.handleChange('dateRange', value);
                }}
              />
            </Grid>
          ) : null}
          <Grid item container justifyContent="space-around" sm={3} xs={12}>
            <Tooltip title="Refresh">
              <IconButton
                sx={{
                  bgcolor: 'white',
                  boxShadow: '0 0 4px rgba(0,0,0,0.31)'
                }}
                color="primary"
                size="small"
                onClick={this.props.onRefresh}
              >
                <Refresh color="primary" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reset">
              <IconButton
                sx={{
                  bgcolor: 'white',
                  boxShadow: '0 0 4px rgba(0,0,0,0.31)'
                }}
                color="primary"
                size="small"
                onClick={() => window.location.reload()}
              >
                <ClearIcon color="primary" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

SearchRecords.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  setFilters: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  filterOptions: PropTypes.object.isRequired
};

export default SearchRecords;
